export default [
  {
    value: 'LEGAL',
    title: 'Юридическое лицо'
  },
  {
    value: 'PERSONAL',
    title: 'Физическое лицо'
  }
]
